import React from "react";
import { Link } from "gatsby";
import Gallery from "react-grid-gallery";

import Layout from "../components/layout";
import Seo from "../components/Seo";
import BannerLineas from "../components/BannerLineas";
import ProductoRelacionado from "../components/ProductoRelacionado";

import { listArticulos, getArticulo, getRelacionados } from "../utils/articulos";

import "../assets/css/lucero.css";

const imgArticulos = [];
listArticulos("infantil").forEach(a => {
  imgArticulos.push({
    src: a.img,
    thumbnail: a.img,
    thumbnailWidth: a.width ? a.width : 266,
    thumbnailHeight: 178,
    thumbnailCaption: "Art. " + a.codigo,
    caption: a.descripcion,
    alt: a.descripcion,
  });
});
const relacionados = getRelacionados("bazar");

const LineaInfantil = props => (
  <Layout>
    <Seo
      title="Línea Infantil"
      description="Línea infantil de Plásticos Lucero: vasos sorbito, jarras, cubiertos y artículos plásticos para los primeros meses de vida hasta etapa escolar. Fabricación nacional para mayoristas."
      image={getArticulo("infantil", "290-320").img}
      path="/infantil"
    />

    <BannerLineas
      title="Linea Infantil"
      subTitle="Productos que tienen utilidad, desde los primeros meses de vida hasta el comienzo de etapa escolar"
      image={getArticulo("infantil", "290-320").img}
    />

    <main id="main">
      <section id="one">
        <div className="content">
          <div className="inner">
            <div
              style={{
                display: "block",
                minHeight: "1px",
                width: "100%",
                border: "1px solid #2A2F4A",
                overflow: "auto",
                textAlign: "center",
                background: "#2A2F4A",
              }}>
              <Gallery
                images={imgArticulos}
                enableImageSelection={false}
                backdropClosesModal={true}
                imageCountSeparator="&nbsp;de&nbsp;"
                showCloseButton={false}
                margin={15}
              />
            </div>
          </div>
        </div>
      </section>
      <section id="catalogoCta">
        <div className="inner" style={{ textAlign: "center" }}>
          <header className="major">
            <h2>Catálogo completo</h2>
          </header>
          <p>
            Descargá el catálogo de productos en PDF. Para precios actualizados, disponibilidad por artículo y mínimos
            de pedido, escribinos por mail o teléfono.
          </p>
          <ul
            className="actions"
            style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 15 }}>
            <li>
              <a href="/catalogo.pdf" className="button special" download>
                Descargar catálogo (PDF)
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section id="moreBazar">
        <div className="inner">
          <header className="major">
            <h2>Mirá la linea bazar tambien!</h2>
          </header>
          <div className="grid-wrapper">
            {relacionados.map(pr => (
              <ProductoRelacionado articulo={pr} key={pr.codigo} />
            ))}
          </div>
          <ul
            className="actions"
            style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 15 }}>
            <li>
              <Link to="/bazar" className="button next">
                VER MAS
              </Link>
            </li>
          </ul>
        </div>
      </section>
    </main>
  </Layout>
);

export default LineaInfantil;
